import { NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import { List, useTheme, Typography } from '@mui/material'
import PtRoutes from '../../PtRoutes'
import { StaticView } from '../../shared/model'
import { useAppSelector } from '../../store/hooks'
import { getIcon } from '../common/Icons'

const PtNavigation = ({ isHovered }: { isHovered?: boolean }) => {
  const location = useLocation()
  const theme = useTheme()
  const { t } = useTranslation()
  const { ptRuns } = useAppSelector((state) => state.currentPt)

  const routeForModule = (moduleName: string) => PtRoutes.find((route) => route.name === moduleName)

  const home = routeForModule(StaticView.PTHOME)
  const kpis = routeForModule(StaticView.PTKPIS)
  const assistance = routeForModule(StaticView.PTASSISSTANCE)
  const upload = routeForModule(StaticView.UPLOAD)

  const noAnalysisYet = ptRuns && ptRuns.length === 0

  return (
    <List>
      <NavLink
        to={home!.path}
        style={{
          textDecoration: 'none',
          justifyContent: 'flex-start',
        }}
        key={`nav-link-${home!.name}`}
      >
        <ListItem
          key={home!.name}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            backgroundColor: location.pathname === '/pt/home' ? theme.palette.action.hover : '',
            py: 1.25,
            px: 1.25,
            borderRadius: 1,
            mt: 1,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 26,
              '& svg': {
                fontSize: 32,
                color: theme.palette.primary.main,
                ml: -0.5,
              },
            }}
          >
            {getIcon(home!.name)}
          </ListItemIcon>
          {isHovered && (
            <Typography
              mt={0.5}
              ml={1}
              color={
                location.pathname === '/pt/home'
                  ? theme.palette.text.primary
                  : theme.palette.text.secondary
              }
            >
              {t(home!.name as any)}
            </Typography>
          )}
        </ListItem>
      </NavLink>
      {!noAnalysisYet && (
        <>
          <NavLink
            to={kpis!.path}
            style={{
              textDecoration: 'none',
              justifyContent: 'flex-start',
            }}
            key={`nav-link-${kpis!.name}`}
          >
            <ListItem
              key={kpis!.name}
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                backgroundColor: location.pathname === '/pt/kpis' ? theme.palette.action.hover : '',
                py: 1.25,
                px: 1.25,
                borderRadius: 1,
                mt: 1,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 26,
                }}
              >
                {getIcon(kpis!.name, {
                  color: theme.palette.primary.main,
                  width: 26,
                  height: 26,
                })}
              </ListItemIcon>
              {isHovered && (
                <Typography
                  ml={1}
                  color={
                    location.pathname === '/pt/kpis'
                      ? theme.palette.text.primary
                      : theme.palette.text.secondary
                  }
                >
                  {t(kpis!.name as any)}
                </Typography>
              )}
            </ListItem>
          </NavLink>
          <NavLink
            to={assistance!.path}
            style={{
              textDecoration: 'none',
              justifyContent: 'flex-start',
            }}
            key={`nav-link-${assistance!.name}`}
          >
            <ListItem
              key={assistance!.name}
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                backgroundColor:
                  location.pathname === '/pt/assistance' ? theme.palette.action.hover : '',
                py: 1.25,
                px: 1.25,
                borderRadius: 1,
                mt: 1,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 26,
                }}
              >
                {getIcon(assistance!.name, {
                  color: theme.palette.primary.main,
                  width: 26,
                  height: 26,
                })}
              </ListItemIcon>
              {isHovered && (
                <Typography
                  ml={1}
                  color={
                    location.pathname === '/pt/assistance'
                      ? theme.palette.text.primary
                      : theme.palette.text.secondary
                  }
                >
                  {t(assistance!.name as any)}
                </Typography>
              )}
            </ListItem>
          </NavLink>
        </>
      )}
      <NavLink
        to={upload!.path}
        style={{
          textDecoration: 'none',
          justifyContent: 'flex-start',
        }}
        key={`nav-link-${upload!.name}`}
      >
        <ListItem
          key={upload!.name}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            backgroundColor:
              location.pathname === '/pt/upload-files' ? theme.palette.action.hover : '',
            py: 1.25,
            px: 1.25,
            borderRadius: 1,
            mt: 1,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 26,
            }}
          >
            {getIcon(upload!.name, {
              color: theme.palette.primary.main,
              width: 26,
              height: 26,
            })}
          </ListItemIcon>
          {isHovered && (
            <Typography
              ml={1}
              color={
                location.pathname === '/pt/upload-files'
                  ? theme.palette.text.primary
                  : theme.palette.text.secondary
              }
            >
              {t(upload!.name as any)}
            </Typography>
          )}
        </ListItem>
      </NavLink>
    </List>
  )
}

export default PtNavigation
